import styled from 'styled-components';

type StyledDealTypeProps = {
  hasWrapperClass: boolean | undefined;
  applyPadding: boolean | undefined;
};

export const StyledInputWithFixedHeight = styled.input`
  font-size: 14px;
`;

export const StyledSelect = styled.select`
  font-size: 14px;
`;

export const StyledInput = styled.input`
  font-size: 14px;
  height: 34px;
  padding: 6px 12px;
`;

export const StyledButton = styled.span`
  height: 34px;
`;

export const StyledSpan = styled.span<StyledDealTypeProps>`
  color: #2186d3;
  padding-left: ${(props) => (props.applyPadding ? '10px' : '0px')};
  padding-right: ${(props) => (props.applyPadding ? '10px' : '0px')};
  text-align: center;
  background-color: hsla(0, 0%, 75%, 0.2);
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  border: 1px solid #ccc;
  border-radius: 4px;
  height: 34px;
  white-space: nowrap;
  vertical-align: middle;
  padding-top: ${(props) => (props.hasWrapperClass ? '0px' : '12px')};
`;
